export default {
	computed: {
		timeLeft() {
			let today = new Date();

			return this.jobIsExpired
				? this.$t('job_expired')
				: this.$t('job_time_left', [this.$dayjs(today).to(this.job?.expires, true)]);
		},

		jobIsExpired() {
			return this.$dayjs(this.job?.expires).isBefore(new Date());
		},
	},
}
